// extracted by mini-css-extract-plugin
export default {"modal":"Pfa-z","modalContent":"Qfa-z","footer":"Rfa-z","cancelBtn":"Sfa-z","disabled":"Tfa-z","formWrapper":"Ufa-z","fade":"Vfa-z","fade-in":"Wfa-z","iframe":"Xfa-z"};